import React from 'react'
import { styles } from './style'

const PrivacyPolictPage = () => {
  const tncStyles = styles()

  return (
    <>
      <div
        style={{
          background: 'white'
        }}
      >
        <div style={{ maxWidth: ' 1200px', margin: '0px auto' }}>
          <img src='/logo.webp' style={{ maxHeight: 60 }} />
        </div>
      </div>
      <div
        style={{
          paddingTop: '24px',
          paddingBottom: '38px',
          maxWidth: ' 1200px',
          margin: '0px auto'
        }}
      >
        <div className='main-container'>
          <h1 className='slug-title'>Privacy Policy</h1>
          <div>
            <p>
              <strong>PT Mota Kasir Indonesia</strong> (“Company”, “we”, “our”, or “us”) builds this
              application as a free app. This Service is provided at no cost and is intended for use
              as is. This Privacy Policy informs users regarding our policies on the collection,
              use, and disclosure of personal information for anyone who decides to use our Service.
              By choosing to use our Service, you agree to the collection and use of information in
              accordance with this Privacy Policy. The personal information that we collect is used
              solely for providing and improving the Service. We will not use or share your
              information with anyone except as described in this Privacy Policy. Unless otherwise
              defined in this Privacy Policy, the terms used here have the same meanings as in our
              Terms and Conditions.
            </p>
            <h6>
              <strong>Information Collection and Use</strong>
            </h6>
            <p>
              For a better experience while using our Service, we may require you to provide certain
              personally identifiable information. The information that we request will be retained
              by us and used as described in this Privacy Policy.
            </p>
            <h6>
              <strong>Log Data</strong>
            </h6>
            <p>
              Whenever you use our Service, in case of an error in the app, we collect data and
              information (through third-party products) on your device called{' '}
              <strong>Log Data</strong>. This Log Data may include information such as:
            </p>
            <ul className={tncStyles.list}>
              <li>Device Internet Protocol (“IP”) address</li>
              <li>Device name</li>
              <li>Operating system version</li>
              <li>Configuration of the app at the time of use</li>
              <li>Time and date of use of the Service</li>
              <li>Other relevant statistics</li>
            </ul>
            <h6>
              <strong>Cookies</strong>
            </h6>
            <p>
              Cookies are files with a small amount of data that are commonly used as anonymous
              unique identifiers.
            </p>
            <p>
              This Service does not use cookies explicitly. However, the app may use third-party
              code and libraries that use cookies to collect information and improve their services.
            </p>
            <p>
              You can choose to accept or refuse cookies and be notified when a cookie is being sent
              to your device. If you choose to refuse cookies, some parts of the Service may not
              function properly.
            </p>
            <h6>
              <strong>Service Providers</strong>
            </h6>
            <p>We may employ third-party companies and individuals for the following purposes:</p>
            <ul className={tncStyles.list}>
              <li>To facilitate our Service</li>
              <li>To provide the Service on our behalf</li>
              <li>To perform Service-related tasks</li>
              <li>To assist us in analyzing how our Service is used</li>
            </ul>
            <p>
              These third parties may have access to your personal information to perform assigned
              tasks on our behalf. However, they are obligated not to disclose or use the
              information for any other purpose.
            </p>
            <h6>
              <strong>Security</strong>
            </h6>
            <p>
              We value your trust in providing us with your personal information. We use
              commercially acceptable means of protecting it. However, no method of transmission
              over the internet or electronic storage is 100% secure. Therefore, we cannot guarantee
              absolute security.
            </p>
            <h6>
              <strong>Links to Other Sites</strong>
            </h6>
            <p>
              This Service may contain links to external sites. If you click on a third-party link,
              you will be directed to that site. Please note that these external sites are not
              operated by us. We strongly advise you to review the Privacy Policy of such websites.
              We assume no responsibility for the content, privacy policies, or practices of any
              third-party sites or services.
            </p>
            <h6>
              <strong>Children’s Privacy</strong>
            </h6>
            <p>
              Our Services do not address anyone under the age of 13. We do not knowingly collect
              personally identifiable information from children under 13. If we discover that a
              child under 13 has provided personal information, we will immediately delete it from
              our servers. If you are a parent or guardian and you are aware that your child has
              provided us with personal information, please contact us so we can take the necessary
              actions.
            </p>
            <h6>
              <strong>Changes to This Privacy Policy</strong>
            </h6>
            <p>
              We may update our Privacy Policy from time to time. You are advised to review this
              page periodically for any updates.
            </p>
            <p>
              We will notify you of any changes by posting the new Privacy Policy on this page.
              These changes become effective immediately after they are posted.
            </p>
            <h6>
              <strong>Contact Us</strong>
            </h6>
            <p>
              If you have any questions or suggestions regarding this Privacy Policy, please contact
              us at: <br />
              <a href='mailto:appsellerstudio@gmail.com'>appsellerstudio@gmail.com</a>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default PrivacyPolictPage
